/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DefaultVipDiscountResponseModel } from '../../models/default-vip-discount-response-model';

export interface GetDefaultVipDiscount$Params {
  defaultVipDiscountId: string;
}

export function getDefaultVipDiscount(http: HttpClient, rootUrl: string, params: GetDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getDefaultVipDiscount.PATH, 'get');
  if (params) {
    rb.path('defaultVipDiscountId', params.defaultVipDiscountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DefaultVipDiscountResponseModel>;
    })
  );
}

getDefaultVipDiscount.PATH = '/discounts/vip/defaults/{defaultVipDiscountId}';
